import { Route, Routes } from "react-router-dom";
import { AppShell } from "../components/layout/AppShell.tsx";
import { AuthPage } from "../pages/AuthPage.tsx";
import { LandingPage } from "../pages/landing/LandingPage.tsx";
import { DailyAccaPage } from "../pages/free/DailyAccaPage.tsx";
import { IntelligenceRecordPage } from "../pages/free/IntelligenceRecordPage.tsx";
import { SuperAccaPage } from "../pages/super-acca/SuperAccaPage.tsx";
import { PricingPage } from "../pages/pricing/PricingPage.tsx";
import { SuccessPage as PricingSuccessPage } from "../pages/pricing/SuccessPage.tsx";
import { NotFoundPage } from "../pages/NotFoundPage.tsx";
import { AgeGatePage } from "../pages/onboarding/AgeGatePage.tsx";
import { JurisdictionGatePage } from "../pages/onboarding/JurisdictionGatePage.tsx";
import { PhantomBetPage } from "../pages/onboarding/PhantomBetPage.tsx";
import { PlatformSelectionPage } from "../pages/onboarding/PlatformSelectionPage.tsx";
import { SafeModePage } from "../pages/onboarding/SafeModePage.tsx";
import { ExchangePage } from "../pages/exchange/ExchangePage.tsx";
import { FairPriceDashboardPage } from "../pages/exchange/FairPriceDashboardPage.tsx";
import { HighConfidenceBoardPage } from "../pages/exchange/HighConfidenceBoardPage.tsx";
import { ClvLineMovementPage } from "../pages/exchange/ClvLineMovementPage.tsx";
import { HomePage } from "../pages/home/HomePage.tsx";
import { CoverageRoadmapPage } from "../pages/sport-coverage/CoverageRoadmapPage.tsx";
import { MarketsCoveragePage } from "../pages/sport-coverage/MarketsCoveragePage.tsx";
import { IntlAccaCalendarRoute } from "../pages/intl-acca/IntlAccaCalendarRoute.tsx";
import { IntlAccaHomeRoute } from "../pages/intl-acca/IntlAccaHomeRoute.tsx";
import { IntlAccaHubRoute } from "../pages/intl-acca/IntlAccaHubRoute.tsx";
import { IntlAccaSlipRoute } from "../pages/intl-acca/IntlAccaSlipRoute.tsx";
import { IntlAccaArchiveRoute } from "../pages/intl-acca/IntlAccaArchiveRoute.tsx";
import { IntlAccaDnaRoute } from "../pages/intl-acca/IntlAccaDnaRoute.tsx";
import { IntlAccaQualifierRoute } from "../pages/intl-acca/IntlAccaQualifierRoute.tsx";
import { IntlAccaDebriefRoute } from "../pages/intl-acca/IntlAccaDebriefRoute.tsx";
import { IntlAccaPassRoute } from "../pages/intl-acca/IntlAccaPassRoute.tsx";
import { IntlAccaResolveRoute } from "../pages/intl-acca/IntlAccaResolveRoute.tsx";
import { IntlAccaLadderRoute } from "../pages/intl-acca/IntlAccaLadderRoute.tsx";
import { IntlAccaRollsRoute } from "../pages/intl-acca/IntlAccaRollsRoute.tsx";
import { IntlBetBuilderRoute } from "../pages/intl-acca/IntlBetBuilderRoute.tsx";
// StubPage import retired in Phase 10A.1 (no remaining stub routes).
// Phase 10A.1 R3 — Brief and Council restored from "migrating" stubs.
// Both pages bring their own UnifiedShell chrome and are mounted
// directly (no AppShell wrapper) to avoid double-chrome. The /brief
// route is the ONLY surface where stake-recommendation copy is allowed.
import { BriefHistoryPage } from "../pages/brief/BriefHistoryPage.tsx";
import { BriefPhantomPage } from "../pages/brief/BriefPhantomPage.tsx";
import { CouncilPreviewPage } from "../pages/council/CouncilPreviewPage.tsx";
import { VaultHomePage } from "../pages/vault/VaultHomePage.tsx";
import { WatchlistPage } from "../pages/watchlist/WatchlistPage.tsx";
import { SikaChatPage } from "../pages/sika/SikaChatPage.tsx";
import { SikaGoalPage } from "../pages/sika/SikaGoalPage.tsx";
import { SikaPortfolioPage } from "../pages/sika/SikaPortfolioPage.tsx";
import { PitchPage } from "../pages/pitch/PitchPage.tsx";
import { SinglesPage } from "../pages/singles/SinglesPage.tsx";
import { StreaksPage } from "../pages/streaks/StreaksPage.tsx";
import { RolloverPage } from "../pages/rollover/RolloverPage.tsx";
import { RolloverArchivePage } from "../pages/rollover/RolloverArchivePage.tsx";
import { RolloverUpcomingPage } from "../pages/rollover/RolloverUpcomingPage.tsx";
import { RolloverFlexPage } from "../pages/rollover/RolloverFlexPage.tsx";
import { PowerballPage } from "../pages/powerball/PowerballPage.tsx";
import { UnderDogsPage } from "../pages/under-dogs/UnderDogsPage.tsx";
import { FormElitePage } from "../pages/form-elite/FormElitePage.tsx";
import { PowerballHistoryPage } from "../pages/powerball/PowerballHistoryPage.tsx";
import { GoalsGalorePage } from "../pages/goals-galore/GoalsGalorePage.tsx";
import { DerivativesPage } from "../pages/derivatives/DerivativesPage.tsx";
import { LadderPage } from "../pages/ladder/LadderPage.tsx";
import { StrategyPlannerPage } from "../pages/strategy/StrategyPlannerPage.tsx";
import { ArchetypeSurveyPage } from "../pages/onboarding/ArchetypeSurveyPage.tsx";
import { BankrollDeclarationPage } from "../pages/onboarding/BankrollDeclarationPage.tsx";
import { ClvEducationPage } from "../pages/onboarding/ClvEducationPage.tsx";
import { FirstWeekPlanPage } from "../pages/onboarding/FirstWeekPlanPage.tsx";
import { OwlPage } from "../pages/owl/OwlPage.tsx";
import { ReportsPage } from "../pages/reports/ReportsPage.tsx";
import { AuditPage } from "../pages/audit/AuditPage.tsx";
import { KnowledgePage } from "../pages/knowledge/KnowledgePage.tsx";
import { BankrollPage } from "../pages/bankroll/BankrollPage.tsx";
import { BoardsPage } from "../pages/boards/BoardsPage.tsx";
import { DeskPage } from "../pages/desk/DeskPage.tsx";
import { IntelligencePage } from "../pages/intelligence/IntelligencePage.tsx";
import { SignalsPage } from "../pages/signals/SignalsPage.tsx";
import { LeagueBoardScreen } from "../pages/leagues/LeagueBoardScreen.tsx";
import { TennisPage } from "../pages/tennis/TennisPage.tsx";
import { TennisProductsHub } from "../pages/tennis/products/TennisProductsHub.tsx";
import { TennisProductRoute } from "../pages/tennis/products/TennisProductRoute.tsx";
import { TennisDashboard } from "../pages/tennis/products/TennisDashboard.tsx";
import { BasketballPage } from "../pages/basketball/BasketballPage.tsx";
import { InternationalPage } from "../pages/international/InternationalPage.tsx";
import { FriendliesPage } from "../pages/international/FriendliesPage.tsx";
import { BreakTheBankPage } from "../pages/international/BreakTheBankPage.tsx";
import { SlipAutopsyPage } from "../pages/slips/SlipAutopsyPage.tsx";
import { SlipExtractorPage } from "../pages/extractor/SlipExtractorPage.tsx";
import { SwarmPage } from "../pages/swarm/SwarmPage.tsx";
import { SlipRepairPage } from "../pages/repair/SlipRepairPage.tsx";
import { SlipRepairSharePage } from "../pages/repair/SlipRepairSharePage.tsx";
import { AgentsPage } from "../pages/agents/AgentsPage.tsx";
import { TrustPage } from "../pages/trust/TrustPage.tsx";
import { UserDashboardPage } from "../pages/dashboard/UserDashboardPage.tsx";
import { AdminDashboardPage } from "../pages/dashboard/AdminDashboardPage.tsx";
import { CostDashboardPage } from "../pages/admin/CostDashboardPage.tsx";
import { ActivationPanelPage } from "../pages/admin/ActivationPanelPage.tsx";
import { OddsHealthPage } from "../pages/admin/OddsHealthPage.tsx";
import { AdminOnly } from "../components/admin/AdminOnly.tsx";
import { TemplatesPageRoute } from "../pages/templates/TemplatesPageRoute.tsx";
import { AcademyPage } from "../pages/academy/AcademyPage.tsx";
import { DisplayPreferencesPage } from "../pages/settings/DisplayPreferencesPage.tsx";

export function AppRoutes(): JSX.Element {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth" element={<AuthPage />} />
      {/* Public free shop window — no AppShell. Anon-readable. */}
      <Route path="/daily-acca" element={<DailyAccaPage />} />
      {/* T3.3 — public extraction-intelligence record (no login). */}
      <Route
        path="/intelligence-record"
        element={<IntelligenceRecordPage />}
      />

      {/* SR-SHARE-LANDING (#321) — public read-only landing for a 72h
          Slip Repair share token. No AppShell, no login. Matches the
          /r/:token URL pattern minted by slip-repair-api/share. Doctrine
          enforced inside the page (outputs only, no methodology). */}
      <Route path="/r/:token" element={<SlipRepairSharePage />} />

      {/* RV-5 — Upcoming Picks Board (anon-readable). No AppShell — page
          brings its own header. Matches the /daily-acca free-shop pattern. */}
      <Route path="/rollover/upcoming" element={<RolloverUpcomingPage />} />

      {/* RV-6 — FLEX Builder page (anon-readable for the builder area; the
          lock RPC requires auth — surfaced inline by the panel). */}
      <Route path="/rollover/flex" element={<RolloverFlexPage />} />

      {/* Settings — display preferences (direction toggles). Anon-readable,
          localStorage only. No AppShell. */}
      <Route path="/settings/display" element={<DisplayPreferencesPage />} />

      {/* Pricing — destination for the UpgradeModal CTA + landing-nav
          link. Standalone, anon-readable, no AppShell. Reuses the
          landing page's <Pricing /> component. */}
      <Route path="/pricing" element={<PricingPage />} />
      {/* Paystack callback landing — polls paystack_transactions for the
          ?ref reference until status='success' (or 30s timeout). */}
      <Route path="/pricing/success" element={<PricingSuccessPage />} />

      {/* Super Acca — paid Bet Builder (Phase D). Pro+ gated via
          PaywallCard (Phase H Paystack integration). */}
      <Route
        path="/super-acca"
        element={
          <AppShell>
            <SuperAccaPage />
          </AppShell>
        }
      />

      {/* Coverage & Roadmap — honest transparency surface over the
          sports registry + 4-condition gate. Anon-readable. */}
      <Route
        path="/coverage"
        element={
          <AppShell>
            <CoverageRoadmapPage />
          </AppShell>
        }
      />

      {/* Markets transparency — what we model vs explicitly decline,
          with reasons. Anon-readable, no methodology exposed. */}
      <Route
        path="/markets"
        element={
          <AppShell>
            <MarketsCoveragePage />
          </AppShell>
        }
      />

      {/* International Acca (PRD §3 — nested section, not a top-level
          tab). Specific routes precede the catch-all :tournamentId. */}
      <Route
        path="/intl-acca/calendar"
        element={
          <AppShell>
            <IntlAccaCalendarRoute />
          </AppShell>
        }
      />
      <Route
        path="/intl-acca/pass"
        element={
          <AppShell>
            <IntlAccaPassRoute />
          </AppShell>
        }
      />
      <Route
        path="/intl-acca/archive"
        element={
          <AppShell>
            <IntlAccaArchiveRoute />
          </AppShell>
        }
      />
      <Route
        path="/intl-acca/ladder"
        element={
          <AppShell>
            <IntlAccaLadderRoute />
          </AppShell>
        }
      />
      <Route
        path="/intl-acca/rolls"
        element={
          <AppShell>
            <IntlAccaRollsRoute />
          </AppShell>
        }
      />
      <Route
        path="/intl-acca/bet-builder"
        element={
          <AppShell>
            <IntlBetBuilderRoute />
          </AppShell>
        }
      />
      {/* Non-param sidebar entry points — resolve the active
          tournament then redirect to its scoped route (video's IA
          sidebar exposes these as flat destinations). */}
      <Route
        path="/intl-acca/today"
        element={<AppShell><IntlAccaResolveRoute dest="home" /></AppShell>}
      />
      <Route
        path="/intl-acca/hub"
        element={<AppShell><IntlAccaResolveRoute dest="hub" /></AppShell>}
      />
      <Route
        path="/intl-acca/dna"
        element={<AppShell><IntlAccaResolveRoute dest="dna" /></AppShell>}
      />
      <Route
        path="/intl-acca/debrief"
        element={<AppShell><IntlAccaResolveRoute dest="debrief" /></AppShell>}
      />
      {/* Qualifier Intel is window-scoped; no-window entry renders
          the honest-empty state (C-phase data not yet shipped). */}
      <Route
        path="/intl-acca/qualifier"
        element={<AppShell><IntlAccaQualifierRoute /></AppShell>}
      />
      <Route
        path="/intl-acca/qualifier/:windowId"
        element={
          <AppShell>
            <IntlAccaQualifierRoute />
          </AppShell>
        }
      />
      <Route
        path="/intl-acca/debrief/:tournamentId"
        element={
          <AppShell>
            <IntlAccaDebriefRoute />
          </AppShell>
        }
      />
      <Route
        path="/intl-acca/slip/:slipId"
        element={
          <AppShell>
            <IntlAccaSlipRoute />
          </AppShell>
        }
      />
      <Route
        path="/intl-acca/:tournamentId/dna/:teamCode"
        element={
          <AppShell>
            <IntlAccaDnaRoute />
          </AppShell>
        }
      />
      {/* DNA roster entry (no team selected) — honest-empty until a
          team is picked / C-phase DNA data lands. */}
      <Route
        path="/intl-acca/:tournamentId/dna"
        element={
          <AppShell>
            <IntlAccaDnaRoute />
          </AppShell>
        }
      />
      <Route
        path="/intl-acca/:tournamentId/hub"
        element={
          <AppShell>
            <IntlAccaHubRoute />
          </AppShell>
        }
      />
      <Route
        path="/intl-acca/:tournamentId"
        element={
          <AppShell>
            <IntlAccaHomeRoute />
          </AppShell>
        }
      />

      {/* Onboarding */}
      <Route path="/onboarding/age" element={<AgeGatePage />} />
      <Route path="/onboarding/jurisdiction" element={<JurisdictionGatePage />} />
      <Route path="/onboarding/safe-mode" element={<SafeModePage />} />
      <Route path="/onboarding/platform" element={<PlatformSelectionPage />} />
      <Route path="/onboarding/phantom" element={<PhantomBetPage />} />

      {/* ═══ App pages (inside AppShell) ═══ */}

      {/* Workspace */}
      <Route
        path="/home"
        element={
          <AppShell>
            <HomePage />
          </AppShell>
        }
      />
      <Route
        path="/exchange"
        element={
          <AppShell>
            <ExchangePage />
          </AppShell>
        }
      />

      {/* Daily */}
      <Route
        path="/singles"
        element={
          <AppShell>
            <SinglesPage />
          </AppShell>
        }
      />
      <Route
        path="/rollover"
        element={
          <AppShell>
            <RolloverPage />
          </AppShell>
        }
      />
      <Route path="/streaks" element={<AppShell><StreaksPage /></AppShell>} />
      <Route
        path="/rollover/chains"
        element={
          <AppShell>
            <RolloverArchivePage />
          </AppShell>
        }
      />
      <Route
        path="/rollover/:id"
        element={
          <AppShell>
            <RolloverPage />
          </AppShell>
        }
      />

      {/* Weekly */}
      <Route
        path="/powerball"
        element={
          <AppShell>
            <PowerballPage />
          </AppShell>
        }
      />
      <Route
        path="/goals-galore"
        element={
          <AppShell>
            <GoalsGalorePage />
          </AppShell>
        }
      />
      <Route
        path="/powerball/history"
        element={
          <AppShell>
            <PowerballHistoryPage />
          </AppShell>
        }
      />
      {/* PB-G3 — /powerball/:week deep-dive renders PowerballPage with
          useParams() driving usePowerballWeek(targetWeek) + IntelligencePool
          (week-scoped). Closes the PB-G2 deferral. */}
      <Route
        path="/powerball/:week"
        element={
          <AppShell>
            <PowerballPage />
          </AppShell>
        }
      />
      {/* Derivatives */}
      <Route
        path="/under-dogs"
        element={<AppShell><UnderDogsPage /></AppShell>}
      />
      <Route path="/form-elite" element={<AppShell><FormElitePage /></AppShell>} />
      <Route
        path="/derivatives"
        element={
          <AppShell>
            <DerivativesPage />
          </AppShell>
        }
      />

      <Route
        path="/strategy"
        element={
          <AppShell>
            <StrategyPlannerPage />
          </AppShell>
        }
      />
      {/* GAP-15b — archetype survey: personalisation, NOT a legal
          gate. Auth-gated via AppShell only; deliberately absent from
          steps.ts so AuthGate's mandatory machinery is untouched. */}
      <Route
        path="/onboarding/archetype"
        element={
          <AppShell>
            <ArchetypeSurveyPage />
          </AppShell>
        }
      />
      {/* GAP-15c — bankroll declaration: user config, NOT a legal
          gate. Auth-gated via AppShell only; absent from steps.ts. */}
      <Route
        path="/onboarding/bankroll"
        element={
          <AppShell>
            <BankrollDeclarationPage />
          </AppShell>
        }
      />
      {/* GAP-15d — CLV education: static, not a legal gate. Auth-gated
          via AppShell only; absent from steps.ts. */}
      <Route
        path="/onboarding/clv"
        element={
          <AppShell>
            <ClvEducationPage />
          </AppShell>
        }
      />
      {/* GAP-15e — first-week plan: orientation, not a legal gate.
          Auth-gated via AppShell only; absent from steps.ts. */}
      <Route
        path="/onboarding/first-week"
        element={
          <AppShell>
            <FirstWeekPlanPage />
          </AppShell>
        }
      />
      <Route
        path="/ladder"
        element={
          <AppShell>
            <LadderPage />
          </AppShell>
        }
      />

      {/* Late Night */}
      <Route
        path="/owl"
        element={
          <AppShell>
            <OwlPage />
          </AppShell>
        }
      />

      {/* Intelligence */}
      <Route
        path="/fair-price"
        element={
          <AppShell>
            <FairPriceDashboardPage />
          </AppShell>
        }
      />
      {/* FPE conviction surface — ranks picks by STRIKZA confidence, not raw probability */}
      <Route
        path="/high-confidence"
        element={
          <AppShell>
            <HighConfidenceBoardPage />
          </AppShell>
        }
      />
      {/* CLV-2 — Line Movement / Beat the Line board */}
      <Route
        path="/clv"
        element={
          <AppShell>
            <ClvLineMovementPage />
          </AppShell>
        }
      />
      {/* SIKA-5c/A — SIKA routes now use the main AppShell so the
          global sidebar (with the collapsible SIKA + SIKA Chat nest
          from SIKA-5b/1) renders. Chat is Panel 5 inline inside
          SikaGoalPage (canonical prototype, frame 22 of video).
          /sika/chat remains a full-bleed deep-link workspace for
          long sessions — same component, different chrome. */}
      <Route
        path="/sika"
        element={
          <AppShell>
            <SikaGoalPage />
          </AppShell>
        }
      />
      <Route
        path="/sika/chat"
        element={
          <AppShell>
            <SikaChatPage />
          </AppShell>
        }
      />
      <Route
        path="/sika/portfolio"
        element={
          <AppShell>
            <SikaPortfolioPage />
          </AppShell>
        }
      />
      <Route
        path="/vault"
        element={
          <AppShell>
            <VaultHomePage />
          </AppShell>
        }
      />
      <Route
        path="/watchlist"
        element={
          <AppShell>
            <WatchlistPage />
          </AppShell>
        }
      />

      {/* Board OS */}
      <Route
        path="/boards"
        element={
          <AppShell>
            <BoardsPage />
          </AppShell>
        }
      />

      {/* THE DESK — daily 18-agent publication (Phase 2 P2-1) */}
      <Route
        path="/desk"
        element={
          <AppShell>
            <DeskPage />
          </AppShell>
        }
      />

      {/* LEAGUES — per-league weekly intelligence (pilot: English Premier
          League). Pure selector over the Weekly Substrate; Pro+ gate lives in
          the page component (PaywallCard). Further leagues reuse this route
          shape with their own canonical name + slug. */}
      <Route
        path="/leagues/epl"
        element={
          <AppShell>
            <LeagueBoardScreen league="Premier League" title="English Premier League" region="England" />
          </AppShell>
        }
      />

      {/* Bankroll Advisory (Phase 2 P2-6) */}
      <Route
        path="/bankroll"
        element={
          <AppShell>
            <BankrollPage />
          </AppShell>
        }
      />

      {/* MUST BUILD Signal Window (Phase 2 P2-4) */}
      <Route
        path="/signals"
        element={
          <AppShell>
            <SignalsPage />
          </AppShell>
        }
      />

      {/* Tennis Intelligence module (Tennis Sidebar Navigation v1.0).
          Default landing = /exchange/tennis/signals. */}
      <Route path="/exchange/tennis" element={<AppShell><TennisPage section="signals" /></AppShell>} />
      <Route path="/exchange/tennis/dashboard" element={<AppShell><TennisDashboard /></AppShell>} />
      <Route path="/exchange/tennis/signals" element={<AppShell><TennisPage section="signals" /></AppShell>} />
      <Route path="/exchange/tennis/tournament" element={<AppShell><TennisPage section="tournament" /></AppShell>} />
      <Route path="/exchange/tennis/clv" element={<AppShell><TennisPage section="clv" /></AppShell>} />
      <Route path="/exchange/tennis/no-bets" element={<AppShell><TennisPage section="no-bets" /></AppShell>} />
      <Route path="/exchange/tennis/markets" element={<AppShell><TennisPage section="markets" /></AppShell>} />
      {/* Tennis bet products — hub + a standalone screen per product (Volume
          Redesign + intelligence layers as bet products). */}
      <Route path="/exchange/tennis/products" element={<AppShell><TennisProductsHub /></AppShell>} />
      <Route path="/exchange/tennis/p/:slug" element={<AppShell><TennisProductRoute /></AppShell>} />

      {/* Basketball workspace (Phase 1a) — dormant pilot landing. Own URL space
          so the sport separation is locked in before any agent code lands. All
          sidebar entry points resolve to the honest "in calibration" page; no
          picks/metrics are rendered until the calibration + CLV gates open. */}
      <Route path="/exchange/basketball" element={<AppShell><BasketballPage section="overview" /></AppShell>} />
      <Route path="/exchange/basketball/dashboard" element={<AppShell><BasketballPage section="overview" /></AppShell>} />
      <Route path="/exchange/basketball/slate" element={<AppShell><BasketballPage section="slate" /></AppShell>} />
      <Route path="/exchange/basketball/signals" element={<AppShell><BasketballPage section="signals" /></AppShell>} />
      <Route path="/exchange/basketball/singles" element={<AppShell><BasketballPage section="singles" /></AppShell>} />
      <Route path="/exchange/basketball/clv" element={<AppShell><BasketballPage section="clv" /></AppShell>} />
      {/* Acca Products (Basketball_Acca_Products_v1.0) — dormant pilot screens. */}
      <Route path="/exchange/basketball/first-half" element={<AppShell><BasketballPage section="first-half" /></AppShell>} />
      <Route path="/exchange/basketball/night-shift" element={<AppShell><BasketballPage section="night-shift" /></AppShell>} />
      <Route path="/exchange/basketball/q1-strike" element={<AppShell><BasketballPage section="q1-strike" /></AppShell>} />
      <Route path="/exchange/basketball/hardwood-slip" element={<AppShell><BasketballPage section="hardwood-slip" /></AppShell>} />
      <Route path="/exchange/basketball/powerball" element={<AppShell><BasketballPage section="powerball" /></AppShell>} />
      <Route path="/exchange/basketball/spread-fade" element={<AppShell><BasketballPage section="spread-fade" /></AppShell>} />
      <Route path="/exchange/basketball/gauntlet" element={<AppShell><BasketballPage section="gauntlet" /></AppShell>} />
      <Route path="/exchange/basketball/big6/totals" element={<AppShell><BasketballPage section="big6-totals" /></AppShell>} />
      <Route path="/exchange/basketball/big6/spread" element={<AppShell><BasketballPage section="big6-spread" /></AppShell>} />
      <Route path="/exchange/basketball/big6/props" element={<AppShell><BasketballPage section="big6-props" /></AppShell>} />
      <Route path="/exchange/basketball/big6/global" element={<AppShell><BasketballPage section="big6-global" /></AppShell>} />
      <Route path="/exchange/basketball/big6/nonnba" element={<AppShell><BasketballPage section="big6-nonnba" /></AppShell>} />
      <Route path="/exchange/basketball/big6/b2b" element={<AppShell><BasketballPage section="big6-b2b" /></AppShell>} />
      <Route path="/exchange/basketball/no-bets" element={<AppShell><BasketballPage section="no-bets" /></AppShell>} />
      <Route path="/exchange/basketball/leagues" element={<AppShell><BasketballPage section="leagues" /></AppShell>} />

      {/* International workspace (Sport Workspaces v1.1) — 4th sport-switcher
          sibling. Dashboard landing + 4 honest-empty sections; LADDER-Intl /
          International Acca / Tournaments deep-link into the existing
          /intl-acca/* route tree (also claimed by this workspace). */}
      <Route path="/exchange/international" element={<AppShell><InternationalPage section="dashboard" /></AppShell>} />
      <Route path="/exchange/international/dashboard" element={<AppShell><InternationalPage section="dashboard" /></AppShell>} />
      <Route path="/exchange/international/signals" element={<AppShell><InternationalPage section="signals" /></AppShell>} />
      <Route path="/exchange/international/wc-2026" element={<AppShell><InternationalPage section="wc-hub" /></AppShell>} />
      <Route path="/exchange/international/rounds" element={<AppShell><InternationalPage section="rounds" /></AppShell>} />
      <Route path="/exchange/international/friendlies" element={<AppShell><FriendliesPage /></AppShell>} />
      <Route path="/exchange/international/break-the-bank" element={<AppShell><BreakTheBankPage /></AppShell>} />
      <Route path="/exchange/international/clv" element={<AppShell><InternationalPage section="clv" /></AppShell>} />
      <Route path="/exchange/international/no-bets" element={<AppShell><InternationalPage section="no-bets" /></AppShell>} />

      {/* Slip Autopsy (Phase 2 P2-7) */}
      <Route
        path="/slips/autopsy"
        element={
          <AppShell>
            <SlipAutopsyPage />
          </AppShell>
        }
      />

      {/* Slip Extractor. Inside AppShell so the GLOBAL sidebar stays
         (R-4k refactor): the page no longer ships its own secondary
         sidebar — that was the double-chrome / empty-column problem.
         It now renders as normal content in .page (1480px centered),
         with its own header + sticky Profile/Tool/History sub-nav.
         Starter+ tier gate lives inside the page component. */}
      <Route
        path="/slips/extractor"
        element={
          <AppShell>
            <SlipExtractorPage />
          </AppShell>
        }
      />

      {/* SWARM INTELLIGENCE ENGINE — Slip Analysis (standalone, SOT v1.0). */}
      <Route
        path="/swarm"
        element={
          <AppShell>
            <SwarmPage />
          </AppShell>
        }
      />

      {/* Slip Repair (port slice — STR-PROD-008 v2.1.1 redactions
          applied: generic source pill, why-disclosed deltas,
          unresolved-not-contested, two-phase progress). */}
      <Route
        path="/repair"
        element={
          <AppShell>
            <SlipRepairPage />
          </AppShell>
        }
      />

      {/* Intelligence */}
      <Route
        path="/intelligence"
        element={
          <AppShell>
            <IntelligencePage />
          </AppShell>
        }
      />

      {/* Agents */}
      <Route
        path="/agents"
        element={
          <AppShell>
            <AgentsPage />
          </AppShell>
        }
      />

      {/* Trust Center */}
      <Route
        path="/trust"
        element={
          <AppShell>
            <TrustPage />
          </AppShell>
        }
      />

      {/* Dashboards */}
      <Route
        path="/dashboard"
        element={
          <AppShell>
            <UserDashboardPage />
          </AppShell>
        }
      />
      <Route
        path="/admin"
        element={
          <AppShell>
            <AdminOnly>
              <AdminDashboardPage />
            </AdminOnly>
          </AppShell>
        }
      />
      <Route
        path="/admin/cost"
        element={
          <AppShell>
            <AdminOnly>
              <CostDashboardPage />
            </AdminOnly>
          </AppShell>
        }
      />
      <Route
        path="/admin/activation"
        element={
          <AppShell>
            <AdminOnly>
              <ActivationPanelPage />
            </AdminOnly>
          </AppShell>
        }
      />

      {/* Odds health — Phase OP slice 6. Founder-only. */}
      <Route
        path="/admin/odds-health"
        element={
          <AppShell>
            <AdminOnly>
              <OddsHealthPage />
            </AdminOnly>
          </AppShell>
        }
      />

      {/* Academy */}
      <Route
        path="/academy"
        element={
          <AppShell>
            <AcademyPage />
          </AppShell>
        }
      />

      {/* Templates */}
      <Route
        path="/templates"
        element={
          <AppShell>
            <TemplatesPageRoute />
          </AppShell>
        }
      />

      {/* Tools */}
      <Route
        path="/reports"
        element={
          <AppShell>
            <ReportsPage />
          </AppShell>
        }
      />
      <Route
        path="/audit"
        element={
          <AppShell>
            <AuditPage />
          </AppShell>
        }
      />
      <Route
        path="/knowledge"
        element={
          <AppShell>
            <KnowledgePage />
          </AppShell>
        }
      />

      {/* Restored real surfaces (Phase 10A.1 R3). Mounted WITHOUT
          AppShell because each ships its own UnifiedShell — wrapping
          would double the chrome. Stake-recommendation copy is
          permitted only inside /brief (and /brief/history). */}
      <Route path="/brief" element={<BriefPhantomPage />} />
      <Route path="/brief/history" element={<BriefHistoryPage />} />
      <Route path="/council" element={<CouncilPreviewPage />} />
      <Route
        path="/pitch"
        element={
          <AppShell>
            <PitchPage />
          </AppShell>
        }
      />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
